import {ArrowClockwise as Reload} from 'react-bootstrap-icons';
import Spinner from 'react-bootstrap/Spinner';
import {useSpinnerStatusContext} from "../hook/UseSpinnerStatusContext";

export type OnClickReload = () => void

interface ReloadButtonProps {
    onClickReload : OnClickReload
}

export const ReloadButton = ({onClickReload} : ReloadButtonProps) =>
{
    const {spinnerStateCounter} = useSpinnerStatusContext();

    return (
        <span className="btn btn-link" >
            {spinnerStateCounter > 0 && <Spinner size="sm" animation="border" variant="primary"/>}
            {spinnerStateCounter === 0 && <Reload onClick={onClickReload} title="Reload"/>}
        </span>
    )
}